import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { Field, formValueSelector } from 'redux-form';
import InputField from 'forms/shared/fields/input'
import InputWithPrefixField from 'forms/shared/fields/input-with-prefix'
import TextAreaField from 'forms/shared/fields/text-area'
import SelectDropdownField from 'forms/shared/fields/dropdown'
import DatePickerDropdownField from 'forms/shared/fields/date-picker-dropdown-draggable'
import TimePickerDropdownField from 'forms/shared/fields/time-picker-dropdown'
import UploaderField from 'forms/shared/fields/uploader'

const Fields = ({ form, spaceOptions, space }) => {
  const [currency, setCurrency] = useState('PHP')
  useEffect(() => {
    const selectedSpace = spaceOptions.find(s => s.value === space)
    if (selectedSpace) {
      setCurrency(selectedSpace.currency.name)
    }
  }, [space, spaceOptions])

  return (
    <>
      <Field
        type="dropdown"
        name="space"
        options={spaceOptions}
        label="Space"
        labelClassName="font-semibold text-sm mb-1"
        placeholder={'Space'}
        groupClassName="my-4"
        inputClassName="pl-2 pt-2 regular text-xs"
        inputGroupClassName=""
        inputErrorClassName="border-action-danger"
        errorClassName="text-action-danger text-xs slab"
        component={SelectDropdownField}
      />
      <Field
        type="dropdown"
        name="schedule"
        label="Check-in/Check-out"
        showText={false}
        labelClassName="font-semibold text-sm mb-1"
        groupClassName="my-4"
        inputClassName="pl-2 pt-2 regular text-xs"
        placeholderClassName='text-sm text-primary-lightgray'
        inputGroupClassName=""
        inputErrorClassName="border-action-danger"
        errorClassName="text-action-danger text-xs slab"
        component={DatePickerDropdownField}
      />
      <div className="flex w-full my-4">
        <Field
          type="dropdown"
          name="startTime"
          showText={false}
          label="Start Time"
          labelClassName="font-semibold text-sm mb-1"
          placeholder="Select start time"
          placeholderClassName='text-sm text-primary-lightgray'
          groupClassName="mr-1 w-full"
          inputClassName="pl-2 pt-2 regular text-xs"
          inputGroupClassName=""
          inputErrorClassName="border-action-danger"
          errorClassName="text-action-danger text-xs slab"
          component={TimePickerDropdownField}
        />
        <Field
          type="dropdown"
          name="endTime"
          label="End Time"
          showText={false}
          labelClassName="font-semibold text-sm mb-1"
          placeholder="Select end time"
          placeholderClassName='text-sm text-primary-lightgray'
          groupClassName="ml-1 w-full"
          inputClassName="pl-2 pt-2 regular text-xs"
          inputGroupClassName=""
          inputErrorClassName="border-action-danger"
          errorClassName="text-action-danger text-xs slab"
          component={TimePickerDropdownField}
        />
      </div>
      <Field
        type="number"
        name="noOfGuests"
        label="Number of Guests"
        labelClassName="font-semibold text-sm mb-1"
        groupClassName="my-4"
        placeHolder="Type in number of guests"
        inputClassName="block border text-sm border-grey-light w-full p-3 rounded-lg"
        inputGroupClassName=""
        inputErrorClassName="border-action-danger"
        errorClassName="text-action-danger text-xs slab"
        component={InputField}
      />
      <div className="my-4">
        <Field
          type="text"
          name="amount"
          placeHolder="Total amount"
          prefix={`${currency}`}
          label="Total Amount"
          labelClassName="font-semibold text-sm mb-1"
          inputClassName="border text-sm border-grey-light rounded-lg py-3"
          inputGroupClassName=""
          inputErrorClassName="border-action-danger"
          errorClassName="text-action-danger text-xs slab"
          component={InputWithPrefixField}
        />
        <p className="text-primary-lightgray text-sm mt-1">Please include GST/VAT in the total amount</p>
      </div>
      <Field
        type="text"
        name="notes"
        groupClassName="my-4"
        placeholder="Notes"
        label="Notes"
        labelClassName="font-semibold text-sm mb-1"
        inputClassName="block border text-sm border-grey-light w-full p-3 rounded-lg"
        inputGroupClassName=""
        inputErrorClassName="border-action-danger"
        errorClassName="text-action-danger text-xs slab"
        component={TextAreaField}
      />
      <div className="my-8">
        <p className="font-bold">Attachment</p>
        <p className="text-primary-lightgray">Allowed files are jpg, jpeg, png, pdf, docx, xslx</p>
        <UploaderField
          form={form}
          name={'attachments'}
          apiRoute={`/upload/attachment/`}
          acceptedFiles=
            'image/jpg, image/jpeg, image/png, application/pdf, .doc, .docx, .xls, .xlsx, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
          groupClassName=""
        />
      </div>
    </>
  );
}

Fields.propTypes = {
  form: PropTypes.string.isRequired,
  spaceOptions: PropTypes.array,
  space: PropTypes.number
}

const mapStateToProps = ({ ...state }, { form }) => {
  const selector = formValueSelector(form)
  return {
    space: selector(state, 'space'),
  }
}

export default connect(mapStateToProps, null)(Fields);
